module.exports = __webpack_public_path__ + "static/media/14-days-offer-mobile.bc4d7453.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/14-days-offer-mobile.jpg
// module id = 2214
// module chunks = 0